import { Directive, ElementRef, model, OnInit, inject } from '@angular/core'


@Directive({
  selector: '[selectableOnOpen]',
})
export class SelectableOnOpenDirective implements OnInit {
  eleRef = inject(ElementRef)

  selectOnOpen = model(false)
  ngOnInit(): void {
    if (this.selectOnOpen()) {
      this.eleRef.nativeElement.select()
    }
  }
}
